import script from "./QuestionGenProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionGenProgress.vue?vue&type=script&setup=true&lang=js"

import "./QuestionGenProgress.vue?vue&type=style&index=0&id=4c2ce904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2ce904"]])

export default __exports__